import { Fragment } from 'react'
import { GetStaticPropsContext, NextPage } from 'next'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import TutorOnDemandBlog from '~/tutor-on-demand/pages/TutorOnDemandBlog.page'
import Metatags from '~/components/Metadata/Metatags'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { useGetBlogPostsListQuery, getBlogPostsList, getRunningQueriesThunk } from '~/redux/apis/blog.api'
import { usePageTitle } from '~/utils/tags'
import { GetProps } from '~/utils/pageWrapper/types'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'

const TutorOnDemandBlogIndexPage: NextPage = () => {
  const { t } = useTranslation('blog')
  const title = usePageTitle(t('title'))

  const { locale, isFallback } = useRouter()
  const { data = [] } = useGetBlogPostsListQuery({ language: locale as string }, { skip: isFallback })

  return (
    <Fragment>
      <Metatags metaDescription={t('metaDescription')} title={title} />

      <DefaultLayout>
        <TutorOnDemandBlog articles={data} />
      </DefaultLayout>
    </Fragment>
  )
}

export const getProps: GetProps =
  (store) =>
  async ({ locale }: GetStaticPropsContext) => {
    store.dispatch(
      getBlogPostsList.initiate({
        language: locale as string,
      }),
    )

    await Promise.all(store.dispatch(getRunningQueriesThunk()))

    const queries = store.getState().blogApi.queries
    const query = Object.values(queries).find((q) => q?.endpointName === 'getBlogPostsList')
    const data = query ? (query.data as unknown[]) : []

    if (data.length === 0) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        namespaces: ['tutorOnDemand', 'blog', ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES],
      },
      revalidate: process.env.ENVIRONMENT === 'staging' ? 30 : false,
    }
  }

export const getStaticProps = getStaticPropsWrapper(getProps)
export default TutorOnDemandBlogIndexPage
